const textFieldFormCompany = {
  name: 'Corporate Name',
  tradingName: 'Fantasy name',
  cnpj: 'Company National ID',
  email: 'Email',
  accountable: 'Accountable',
  phone: 'Contact numbers',
};

export default textFieldFormCompany;
